/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { Card } from '../../routes/home/partials/cards';
import { useSelector } from 'react-redux';
import { isStaff } from '../../selectors/user';
import { useAppClickHandlers } from '../../hooks/useAppClickHandlers';
import DisambiguationModal, { DisambiguationModalProps } from '../../routes/home/partials/DisambiguationModal';

interface ProductCardProps {
  bgColour?: string;
  textColour?: string;
  className?: string;
  actionText?: string;
  actionTextSecondary?: string;
  btnOutline?: boolean;
  onClick?: () => void;
  children?: JSX.Element | JSX.Element[];
}

const ProductCard = (props: ProductCardProps) => {
  const { bgColour, textColour, className, actionText, actionTextSecondary, onClick } = props;
  const isStaffUser = useSelector(isStaff);

  const backgroundClassName = bgColour ? `background-colour${bgColour}` : '';
  const textClassName = textColour ? `text-colour${textColour}` : '';

  return (
    <div className={`hp-card d-flex flex-row ${backgroundClassName} ${textClassName} ${className ?? ''} ${onClick ? 'hover' : ''}`} >
      <div className='hp-card-contents flex-fill'>
        {props.children}
      </div>
      {onClick ? (
        <div className='text-center mt-1 d-flex flex-column ml-3' >
          <Button color='transparent' outline onClick={onClick} >
            {actionText}
          </Button>
          {actionTextSecondary && <Button disabled={!isStaffUser} outline color='primary' className='mt-3'>
            {actionTextSecondary}
          </Button>}
        </div>
      ) : null}
    </div>
  );
}

interface ProductCardGridProps {
  cards: Card[];
  toggleRequestDemoModal: () => void;
  isLoggedIn: boolean;
}

export const ProductCardGrid = ({ cards, toggleRequestDemoModal, isLoggedIn }: ProductCardGridProps) => {

  const [disambiguationModal, setDisambiguationModal] = useState<DisambiguationModalProps | undefined>(undefined);
  const clickHandlers = useAppClickHandlers({ toggleRequestDemoModal, setDisambiguationModal });

  return <div
    className='hp-card-grid d-flex flex-wrap' >
    {disambiguationModal ? <DisambiguationModal {...disambiguationModal} /> : null}
    {cards
      .map((card, i) => (
        <ProductCard
          key={`hp-card-${i}`}
          actionText={isLoggedIn ? 'Access now' : 'Book a demo'}
          actionTextSecondary={card.slug !== 'portfolio-tracker' && card.actionTextSecondary ? card.actionTextSecondary : ''}
          onClick={card.clickHandler && isLoggedIn ? clickHandlers[card.clickHandler] : clickHandlers['ShowRequestADemo']}
          btnOutline={card.btnOutline}
        >
          <div className='h-100 d-flex flex-column'>
            {card.logo ? (
              <div className='product-card-logo solution-card-logo price-logo text-right d-flex justify-content-center align-items-center position-relative'>
                <img src={card.logo} alt={'Logo'} width='125' />
                <div className='position-absolute pl-2 pb-1' style={{ bottom: 0, left: 0 }}>
                  <img src={card.sponsoredByLogo} width={70} alt='Sponsor' />
                </div>
              </div>
            ) : <></>
            }
          </div>
        </ProductCard>
      ))}
  </div>
}


export default ProductCard;
